import { ApiService } from "../apiService";

export class ReportService extends ApiService {
    constructor() {
        super();

        this.path = '/Report';
    }

    getReportInfo(plate, startDate, endDate) {
        return this.get(this.path + "?vehiclePlate=" + plate + "&startSearch=" + startDate + "&endSearch=" + endDate);
    }

    getDocumentsRs232Info(deviceId, startDate, endDate) {
        return this.get(this.path + "/suntecRs232?deviceId=" + deviceId + "&startSearch=" + startDate + "&endSearch=" + endDate);
    }

}